/* VN · Carrito estilo Ana Martínez
   - UNA sola cuenta atrás de 5 min por sesión: arranca al entrar el primer producto, nunca se reinicia ni se pausa (aunque vacíes el carrito) y al acabar se queda terminada hasta que se cierra la sesión (sessionStorage).
   - Barra de descuentos 10 % (2 uds.) · 20 % (3 uds.) · 25 % (4 uds.) con animación y confeti.
   - Con el carrito vacío, el icono de la bolsa lleva a /cart (como la competencia): lo hace el script de snippets/vn-menu-featured.liquid (aquí ya no, para que la X del cajón vacío solo cierre el cajón).
   Va en todas las páginas porque los <script> del cajón (que llega por morph) no se ejecutan. */
(function () {
  if (window.__vnCartAna) return;
  window.__vnCartAna = true;

  var C = 339.3, TOT = 5 * 60000, KT = 'vn_amg_tm_end_s', KN = 'vn_amg_rw_n', mem = 0;
  var COLS = ['#9d1b1b', '#2b1414', '#e0a3a3', '#f2c9c9', '#c44a4a', '#ffffff'];
  var RED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function sget(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function sset(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

  /* nodeValue y no textContent: así no se despiertan los observadores del tema */
  function setText(el, s) {
    if (!el) return;
    var t = el.firstChild;
    if (t && t.nodeType === 3 && !t.nextSibling) { if (t.nodeValue !== s) t.nodeValue = s; }
    else el.textContent = s;
  }

  /* ── Temporizador (uno por sesión, no se reinicia nunca) ── */
  var tmTimer = null;

  function tmEnd() {
    var e = parseInt(sget(KT), 10);
    if (!e || isNaN(e)) e = mem;
    if (!e) { e = Date.now() + TOT; mem = e; sset(KT, String(e)); }
    return e;
  }

  function tmMode(tm, mode) {
    if (tm.__mode === mode) return;
    tm.__mode = mode;
    var tt = tm.querySelector('[data-tm-t]'), ts = tm.querySelector('[data-tm-s]');
    tm.classList.toggle('tm-urge', mode === 'urge');
    tm.classList.toggle('tm-end', mode === 'end');
    if (mode === 'end') {
      setText(tt, 'Finaliza tu pedido 🤍'); setText(ts, 'Disponibilidad no garantizada');
    } else if (mode === 'urge') {
      setText(tt, 'Último minuto 🔥'); setText(ts, 'Asegura tu talla ahora');
    } else {
      setText(tt, 'Tu cesta está guardada ✨'); setText(ts, 'Últimas tallas · Series cortas');
    }
  }

  /* Devuelve los ms que quedan (<0 = terminado) */
  function tmRender(tm) {
    var r = tmEnd() - Date.now();
    var arc = tm.querySelector('.tm-arc'), vm = tm.querySelector('[data-tm-min]'), vs = tm.querySelector('[data-tm-seg]');
    if (r < 0) {
      tmMode(tm, 'end');
      arc.style.strokeDashoffset = C;
      setText(vm, '--'); setText(vs, '--');
      return r;
    }
    var s = Math.ceil(r / 1000), m = Math.floor(s / 60);
    s = s % 60;
    setText(vm, String(m)); setText(vs, (s < 10 ? '0' : '') + s);
    arc.style.strokeDashoffset = (C * (1 - r / TOT)).toFixed(2);
    tmMode(tm, r < 60000 ? 'urge' : 'run');
    return r;
  }

  function tmLoop() {
    clearTimeout(tmTimer);
    var tm = document.querySelector('#cart-drawer #amg-tm');
    if (!tm || !tm.offsetWidth) return;
    var r = tmRender(tm);
    if (r >= 0) tmTimer = setTimeout(tmLoop, (r % 1000) + 8);
  }

  /* ── Confeti ── */
  function confeti(box, cant, o) {
    if (RED) return;
    var cv = box.querySelector('.rw-conf'); if (!cv) return;
    var w = box.offsetWidth, h = box.offsetHeight, dpr = window.devicePixelRatio || 1;
    cv.width = w * dpr; cv.height = h * dpr;
    var ctx = cv.getContext('2d'); ctx.scale(dpr, dpr);
    var p = [], i;
    for (i = 0; i < cant; i++) {
      var a = (-Math.PI / 2) + (Math.random() - 0.5) * (o.spread || 2), v = (o.vel || 3) * (0.55 + Math.random() * 0.9);
      p.push({
        x: o.x, y: o.y, vx: Math.cos(a) * v, vy: Math.sin(a) * v, g: 0.11 + Math.random() * 0.05,
        an: Math.random() * 6.28, va: (Math.random() - 0.5) * 0.3, a2: Math.random() * 6.28, a2v: 0.12 + Math.random() * 0.12,
        w: 3 + Math.random() * 3, hh: 5 + Math.random() * 4, c: COLS[(Math.random() * COLS.length) | 0],
        vida: 0, max: 55 + Math.random() * 40
      });
    }
    (function paso() {
      ctx.clearRect(0, 0, w, h);
      var vivos = 0;
      for (var j = 0; j < p.length; j++) {
        var q = p[j]; if (q.vida > q.max) continue; vivos++; q.vida++;
        q.x += q.vx; q.y += q.vy; q.vy += q.g; q.vx *= 0.99; q.an += q.va; q.a2 += q.a2v;
        var al = q.vida > q.max * 0.65 ? 1 - (q.vida - q.max * 0.65) / (q.max * 0.35) : 1;
        ctx.save(); ctx.globalAlpha = Math.max(0, al); ctx.translate(q.x, q.y); ctx.rotate(q.an);
        ctx.fillStyle = q.c; ctx.fillRect(-q.w / 2, -q.hh / 2, q.w, q.hh * Math.abs(Math.cos(q.a2)) + 1); ctx.restore();
      }
      if (vivos) requestAnimationFrame(paso); else ctx.clearRect(0, 0, w, h);
    })();
  }

  /* ── Barra de artículos ── */
  function rwPaint(box, n, prev, first) {
    var m1 = +box.dataset.m1 || 2, p1 = +box.dataset.p1 || 10,
        m2 = +box.dataset.m2 || 3, p2 = +box.dataset.p2 || 20,
        m3 = +box.dataset.m3 || 4, p3 = +box.dataset.p3 || 25,
        fill = box.querySelector('.rw-fill'),
        n1 = box.querySelector('.rw-n1'), n2 = box.querySelector('.rw-n2'), n3 = box.querySelector('.rw-n3'),
        l1 = box.querySelector('.rw-lg1'), l2 = box.querySelector('.rw-lg2'), l3 = box.querySelector('.rw-lg3'),
        t = box.querySelector('.rw-t'), pill = box.querySelector('.rw-pill'), cnt = box.querySelector('.rw-badge');

    if (prev !== null && n !== prev) { cnt.classList.add('pop'); setTimeout(function () { cnt.classList.remove('pop'); }, 320); }
    setText(cnt, String(n));

    var T = 100 / 3, pct;
    if (n >= m3) pct = 100;
    else if (n >= m2) pct = 2 * T + (n - m2) / Math.max(1, m3 - m2) * T;
    else if (n >= m1) pct = T + (n - m1) / Math.max(1, m2 - m1) * T;
    else pct = n / m1 * T;
    pct = Math.max(0, Math.min(100, pct));

    if (first) {
      fill.style.transition = 'none'; fill.style.width = '0%';
      void fill.offsetWidth;
      fill.style.transition = '';
    } else {
      fill.style.width = '0%';
    }
    requestAnimationFrame(function () { requestAnimationFrame(function () { fill.style.width = pct + '%'; }); });

    var c1 = n >= m1 && prev !== null && prev < m1,
        c2 = n >= m2 && prev !== null && prev < m2,
        c3 = n >= m3 && prev !== null && prev < m3;
    n1.classList.toggle('on', n >= m1); l1.classList.toggle('on', n >= m1);
    n2.classList.toggle('on', n >= m2); l2.classList.toggle('on', n >= m2);
    n3.classList.toggle('on', n >= m3); l3.classList.toggle('on', n >= m3);
    if (c1) { n1.classList.add('pop'); setTimeout(function () { n1.classList.remove('pop'); }, 420); }
    if (c2) { n2.classList.add('pop'); setTimeout(function () { n2.classList.remove('pop'); }, 420); }
    if (c3) { n3.classList.add('pop'); setTimeout(function () { n3.classList.remove('pop'); }, 420); }
    box.classList.toggle('rw-full', n >= m3);

    var f = function (k) { return k === 1 ? '1 artículo más' : k + ' artículos más'; };
    if (n >= m3) {
      t.innerHTML = '¡Enhorabuena! Tienes tu <b>' + p3 + ' %</b> de descuento';
      pill.textContent = p3 + ' %'; pill.classList.add('on');
    } else if (n >= m2) {
      t.innerHTML = 'Añade <b>' + f(m3 - n) + '</b> y obtén un <b>' + p3 + ' %</b>';
      pill.textContent = p2 + ' %'; pill.classList.add('on');
    } else if (n >= m1) {
      t.innerHTML = 'Añade <b>' + f(m2 - n) + '</b> y obtén un <b>' + p2 + ' %</b>';
      pill.textContent = p1 + ' %'; pill.classList.add('on');
    } else {
      t.innerHTML = 'Añade <b>' + f(m1 - n) + '</b> y obtén un <b>' + p1 + ' %</b>';
      pill.textContent = '0 %'; pill.classList.remove('on');
    }

    if (c3) {
      setTimeout(function () {
        confeti(box, 80, { x: box.offsetWidth * 0.78, y: box.offsetHeight * 0.6, spread: 2.5, vel: 4.2 });
        confeti(box, 55, { x: box.offsetWidth * 0.5, y: box.offsetHeight * 0.6, spread: 2.9, vel: 3.8 });
      }, 480);
    } else if (c2 || c1) {
      setTimeout(function () {
        confeti(box, 22, { x: box.offsetWidth * 0.5, y: box.offsetHeight * 0.6, spread: 1.6, vel: 2.8 });
      }, 480);
    }
  }

  /* ── Sincronizar con el cajón ── */
  function sync() {
    var d = document.getElementById('cart-drawer');
    if (!d) return;
    var wrap = d.querySelector('#amg-wrap');
    if (!wrap) {
      /* carrito vacío: solo se reinicia la barra de artículos; la cuenta atrás NO se toca */
      if (d.querySelector('.cart-drawer--empty')) sset(KN, '0');
      return;
    }
    tmEnd(); /* el primer producto de la sesión dispara la cuenta atrás */
    if (!wrap.offsetWidth) return;

    var rw = wrap.querySelector('#amg-rw');
    var n = parseInt(wrap.getAttribute('data-count'), 10) || 0;
    if (rw && rw.__n !== n) {
      var g = parseInt(sget(KN), 10);
      var first = rw.__n === undefined;
      rw.__n = n;
      rwPaint(rw, n, isNaN(g) ? null : g, first);
      sset(KN, String(n));
    }
    tmLoop();
  }

  function init() {
    var d = document.getElementById('cart-drawer');
    if (!d) return;
    new MutationObserver(sync).observe(d, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'data-count'] });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) sync(); });
    sync();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
